import { BaseSelect } from '@/shared/components'
import { FilterButton } from '@/shared/components/FilterButton/FilterButton'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'
import { OptionModel } from '@/shared/lib/types'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'

type Props = {
  selectedIndex: number
  selectFilterBtn: (index: number) => void
  setSearch: (search: string) => void
}

export const DevicesTabs = ({ selectedIndex, selectFilterBtn, setSearch }: Props) => {
  const isMobile = useIsMobile()

  const devicesFilterButtons: FilterButtonModel[] = [
    { name: 'Все', label: 'undefined', index: 0 },
    { name: 'Активные', label: 'active', index: 1 },
    { name: 'Приостановленые', label: 'disabled', index: 2 },
    { name: 'Заблокированные', label: 'blocked', index: 4 },
    { name: 'Не подключено', label: 'notConnected', index: 5 },
  ]

  const deviceChangeStatus: OptionModel[] = [
    { label: 'Активировать', value: 'activete', index: 1 },
    { label: 'Остановить', value: 'stop', index: 2 },
    { label: 'Заблокировать', value: 'block', index: 3 },
  ]
  return (
    <>
      {isMobile ? (
        <div>
          <div className="flex gap-[10px]">
            <BaseSelect
              placeholder="Изменить статус"
              options={deviceChangeStatus}
              className="flex-1"
            />
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              className="flex-1"
              minWidth="150px"
            />
          </div>
          <div className="mt-[30px] mb-[14px] flex gap-1 overflow-x-auto md:overflow-x-visible whitespace-nowrap md:whitespace-normal scrollbar-hide">
            {devicesFilterButtons.map((b) => (
              <FilterButton
                key={b.index}
                name={b.name}
                onClick={() => selectFilterBtn(b.index)}
                selected={b.index === selectedIndex}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="md:flex flex-wrap gap-2 items-center justify-between mb-[40px]">
          <div className="flex items-center gap-2 md:gap-6">
            <div className="flex gap-1 overflow-x-auto md:overflow-x-visible whitespace-nowrap md:whitespace-normal scrollbar-hide">
              {devicesFilterButtons.map((b) => (
                <FilterButton
                  key={b.index}
                  name={b.name}
                  onClick={() => selectFilterBtn(b.index)}
                  selected={b.index === selectedIndex}
                />
              ))}
            </div>
            <div className="min-w-[180px] md:w-50">
              <BaseSelect placeholder="Изменить статус" options={deviceChangeStatus} />
            </div>
          </div>
          <SearchInput onChange={(e) => setSearch(e.target.value)} />
        </div>
      )}
    </>
  )
}
